import React, { useState, useEffect, useRef } from "react";
import CreatableSelect from "react-select/creatable";
import { InputWrap, SelectStyles, LabelWrapper, Error } from "./styled";
import { ChevronIcon, TimesIcon } from "components/svg";
import { components } from "react-select";
import { Label, useThemeUI } from "theme-ui";


const MultiText = ({
  name,
  label,
  options = [],
  value,
  description,
  required,
  disabled,
  readonly,
  clearable,
  $customStyles,
  $responseErrors,
  $errors,
  onChange,
}: {
  name?: string;
  label?: string | React.ReactNode;
  options?: any[];
  value?: string[]; // Expecting array of strings for multi text input
  description?: string;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  clearable?: boolean;
  $customStyles?: any;
  $responseErrors?: any;
  $errors?: any;
  onChange?: (e?: string[]) => void;
}) => {
  const selectRef = useRef<any>(null);
  const themeContext = useThemeUI();
  const { theme } = themeContext;

  const [borderError, setBorderError] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");

  const mappedValue = (value || []).map((val) => ({
    value: val,
    label: val,
  }));

  const handleKeyDown: React.KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    if (event.key === "Enter" || event.key === "Tab") {
      const newOption = inputValue.trim();
      if (!newOption) return;

      const updated = [...(value || []), newOption];
      onChange?.(updated);
      setInputValue("");
      event.preventDefault();
    }
  };

  const handleChange = (selectedOptions: any) => {
    const values = selectedOptions.map((opt: any) => opt.value);
    onChange?.(values);
  };

  useEffect(() => {
    if ($responseErrors || $errors) {
      setBorderError(true);
    } else {
      setBorderError(false);
    }
  }, [$responseErrors, $errors]);

  const ClearIndicator = (props: any) => (
    <components.ClearIndicator {...props}>
      <TimesIcon height="14px" width="14px" fill={theme?.colors?.base_500} />
    </components.ClearIndicator>
  );

  const DropdownIndicator = (props: any) => (
    <components.DropdownIndicator {...props}>
      <ChevronIcon
        height="14px"
        width="14px"
        fill={theme?.colors?.dkgrey}
        transform="rotate(-90deg)"
      />
    </components.DropdownIndicator>
  );

  const MultiValueRemove = (props: any) => (
    <components.MultiValueRemove {...props}>
      <TimesIcon height="10px" width="10px" fill={theme?.colors?.base_800} />
    </components.MultiValueRemove>
  );

  return (
    <InputWrap sx={$customStyles} $errors={borderError}>
      {label && (
        <LabelWrapper>
          <Label>{label}</Label>
          {required ? <span>*</span> : ""}
        </LabelWrapper>
      )}
      <CreatableSelect
        ref={selectRef}
        styles={SelectStyles}
        classNamePrefix="react-select"
        isMulti
        isClearable={clearable}
        isDisabled={disabled || readonly}
        menuPortalTarget={document.body}
        inputValue={inputValue}
        onInputChange={(val) => setInputValue(val)}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        value={mappedValue}
        components={{ MultiValueRemove, ClearIndicator, DropdownIndicator: null }}
        placeholder="Type something and press enter..."
        menuIsOpen={false}
      />
      {description && (
        <p>
          <small>{description}</small>
        </p>
      )}
      {$errors && <Error>{$errors}</Error>}
    </InputWrap>
  );
};

export default MultiText;